@if (visible) {
  <div class="passkey-prompt" data-testid="passkey-prompt">
    <div class="passkey-prompt__card">
      <ion-icon name="finger-print-outline" class="passkey-prompt__icon"></ion-icon>
      <div class="passkey-prompt__text">
        <h3>{{ 'passkey.signInFasterTitle' | translate }}</h3>
        <p>{{ 'passkey.signInFasterDescription' | translate }}</p>
      </div>
      <ion-button
        fill="clear"
        size="small"
        class="passkey-prompt__close"
        (click)="dismiss()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
    <div class="passkey-prompt__actions">
      <ion-button
        fill="clear"
        size="small"
        data-testid="passkey-prompt-dismiss"
        [disabled]="isWorking"
        (click)="dismiss()">
        {{ 'passkey.notNow' | translate }}
      </ion-button>
      <ion-button
        size="small"
        color="primary"
        data-testid="passkey-prompt-accept"
        [disabled]="isWorking"
        (click)="accept()">
        {{ 'passkey.setUpPasskey' | translate }}
      </ion-button>
    </div>
  </div>
}
